// Campaign strings, translated server side by _chancellerie_js_strings() and
// handed over in drupalSettings. See docs/translations.md.
//
// The fallback is the English source string, so the UI still renders if the
// settings are missing — a page cached before this library changed, or the
// script running outside a Drupal page.
export function t(key, fallback) {
    return window.drupalSettings?.chancellerie?.strings?.[key] ?? fallback
}
